module.exports = __webpack_public_path__ + "static/kyaari-320a150de123538b9df54f0f440b2d9c.png";